import request from '@/utils/request'

/**
 * 登录相关 API
 */

// 账号密码登录
export const loginByPassword = (data) => {
  return request({
    url: '/member/login/login',
    method: 'post',
    data
  })
}

// 手机验证码登录
export const codeLoginByPassword = (data) => {
  return request({
    url: '/member/login/code_login',
    method: 'post',
    data
  })
}

// 获取图形验证码（用于短信防刷）
export const getImgCode = (data) => {
  return request({
    url: '/system/sms/get_img_code',
    method: 'post',
    data
  })
}

// 获取手机验证码
export const sendSms = (data) => {
  return request({
    url: '/system/sms/send_sms',
    method: 'post',
    data
  })
}

// 生成微信登录二维码
export const generateQrcode = (data) => {
  return request({
    url: '/member/login/generate_qrcode',
    method: 'post',
    data
  })
}

// 查询扫码结果
export const queryToken = (data) => {
  return request({
    url: '/member/login/query_token',
    method: 'post',
    data
  })
}

// 忘记密码/重置密码（短信验证码）
export const forgetPass = (data) => {
  return request({
    url: '/member/login/forgetPass',
    method: 'post',
    data
  })
}

// 获取微信公众号网页授权链接
export const getAuthUrl = (data) => {
  return request({
    url: '/member/login/getAuthUrl',
    method: 'post',
    data
  })
}

// 微信公众号授权登录（code换token）
export const authByCode = (data) => {
  return request({
    url: '/member/login/authByCode',
    method: 'post',
    data
  })
}

/** 微信 JS-SDK 签名（网页开放标签 wx-open-subscribe）url: 当前页完整地址（不含 #） */
export const getWechatJssdkSign = (data) => {
  return request({
    url: '/member/login/get_jssdk_sign',
    method: 'post',
    data
  })
}
